import { jsx as c, jsxs as f, Fragment as v } from "react/jsx-runtime";
import u from "clsx";
import w, { forwardRef as S, useState as L, useEffect as k, useRef as T, useContext as _ } from "react";
import { C as h, aJ as $, aK as F, L as H, aL as y, i as M, F as z } from "./helpers-458d7e27.js";
const R = "ArrowRightIcon", D = new h(R), O = ({
  ariaLabel: e = "",
  className: t = ""
}) => {
  const o = u(D.getComponentClassName(), t);
  return /* @__PURE__ */ c(
    "svg",
    {
      width: "18",
      height: "19",
      viewBox: "0 0 18 19",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-hidden": !0,
      "aria-label": e,
      className: o,
      children: /* @__PURE__ */ c("path", { d: "M10.7199 14.5282C10.427 14.2353 10.427 13.7604 10.7199 13.4675L13.9396 10.2478H2.25C1.83579 10.2478 1.5 9.91204 1.5 9.49782C1.5 9.08361 1.83579 8.74782 2.25 8.74782H13.9395L10.7199 5.52813C10.427 5.23524 10.427 4.76037 10.7199 4.46747C11.0127 4.17458 11.4876 4.17458 11.7805 4.46747L16.2752 8.9622C16.2798 8.96675 16.2843 8.97133 16.2887 8.97596C16.4195 9.11096 16.5 9.29499 16.5 9.49782C16.5 9.69976 16.4202 9.88304 16.2904 10.0179C16.2867 10.0218 16.2829 10.0257 16.2791 10.0296L16.2772 10.0315L16.2752 10.0335L11.7805 14.5282C11.4876 14.8211 11.0127 14.8211 10.7199 14.5282Z" })
    }
  );
}, A = "CloseIcon", U = new h(A), Z = ({
  ariaLabel: e = "",
  className: t = ""
}) => {
  const o = u(U.getComponentClassName(), t);
  return /* @__PURE__ */ c(
    "svg",
    {
      width: "24",
      height: "25",
      viewBox: "0 0 24 25",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-hidden": !0,
      "aria-label": e,
      className: o,
      children: /* @__PURE__ */ c(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.9997 11.1308L7.25746 6.38877C6.74102 5.87235 5.90372 5.87237 5.3873 6.38881C4.87088 6.90524 4.8709 7.74254 5.38734 8.25896L10.1295 13.0009L5.38752 17.7427C4.87108 18.2591 4.87107 19.0964 5.38749 19.6128C5.90391 20.1293 6.7412 20.1293 7.25764 19.6129L11.9997 14.871L16.7417 19.6128C17.2581 20.1293 18.0954 20.1292 18.6118 19.6128C19.1282 19.0964 19.1282 18.2591 18.6118 17.7427L13.8698 13.0009L18.612 8.25896C19.1284 7.74254 19.1284 6.90525 18.612 6.38881C18.0956 5.87237 17.2583 5.87235 16.7418 6.38877L11.9997 11.1308Z",
          fill: "#001C64"
        }
      )
    }
  );
}, x = S(({ href: e, className: t, children: o, isActive: n = !1, ...s }, r) => {
  const [a, i] = L(n);
  k(() => {
    i(n || !!e && $(e));
  }, [n, e]);
  const l = u(t, {
    "nav-button-type-link-page-active": a
  });
  return w.createElement(
    "a",
    { ref: r, href: e, ...s, className: l },
    o
  );
});
x.displayName = "NavLink";
const G = ({
  children: e,
  ...t
}) => {
  const [o, n] = L(!1), s = T(null), r = () => n(!0), a = () => {
    var l;
    ((l = s.current) == null ? void 0 : l.contains(document.activeElement)) || n(!1);
  };
  return /* @__PURE__ */ c(
    x,
    {
      ref: s,
      onFocus: r,
      onBlur: a,
      onMouseEnter: r,
      onMouseLeave: a,
      onMouseDown: r,
      onMouseUp: a,
      ...t,
      children: e(o)
    }
  );
}, J = ({ children: e, ...t }) => {
  const o = T(null), n = T("none"), { "aria-expanded": s, onClick: r } = t, a = s, i = (l) => {
    n.current = l.detail === 0 ? "keyboard" : "mouse", r && r(l);
  };
  return k(() => {
    !a && n.current === "keyboard" && (setTimeout(() => {
      var l;
      return (l = o.current) == null ? void 0 : l.focus();
    }), n.current = "none");
  }, [a]), w.createElement(
    "button",
    {
      type: "button",
      ref: o,
      ...t,
      onClick: i
    },
    e
  );
}, j = "NavButton", m = new h(j), C = "icon-button", B = {
  collapsible: { accordion: "Body", dropdown: "Body", "nav-popup": "Title" },
  link: { "menu-link": "Body", "nav-link": "Body", "title-link": "Title" }
}, X = (e) => {
  switch (e) {
    case "ppe": {
      const t = JSON.parse(
        JSON.stringify(B)
      );
      return t.collapsible.accordion = "Body Large Bold", t.collapsible["nav-popup"] = "Body Large Bold", t.link["title-link"] = "Body Large Bold", t;
    }
    default:
      return B;
  }
}, P = m.getElementClassName("text"), b = (e) => m.getElementClassName(`icon-${e}`), K = ({
  iconType: e
}) => e === "close" ? /* @__PURE__ */ c(Z, {}) : null, V = ({
  buttonText: e,
  panelType: t,
  buttonTextSize: o = "Body"
}) => /* @__PURE__ */ f(v, { children: [
  (() => {
    const s = /* @__PURE__ */ c(y, { as: "span", size: o, className: P, children: e });
    return t === "nav-popup" ? /* @__PURE__ */ c("span", { className: m.getElementClassName("text-wrapper"), children: s }) : s;
  })(),
  /* @__PURE__ */ c(F, {})
] }), Y = ({
  linkType: e,
  buttonText: t,
  buttonTextSize: o = "Body",
  showArrow: n
}) => {
  const s = () => /* @__PURE__ */ c(y, { as: "span", size: o, className: P, children: t });
  if (e === "nav-link")
    return s();
  if (e === "menu-link") {
    const a = {
      motionFeel: "Expressive",
      motionIntensity: "xs",
      motionTypePreset: "moveRight"
    };
    return (l) => {
      const p = b("arrow-right"), d = u(p, {
        [`${p}-visible`]: l && n
      });
      return /* @__PURE__ */ f(v, { children: [
        s(),
        /* @__PURE__ */ c(
          M,
          {
            as: "span",
            motionOptions: a,
            animate: l ? "animate" : "initial",
            className: d,
            children: /* @__PURE__ */ c(O, {})
          }
        )
      ] });
    };
  }
  const r = b("arrow");
  return /* @__PURE__ */ f(v, { children: [
    s(),
    /* @__PURE__ */ c("span", { className: r, children: /* @__PURE__ */ c(H, { size: "Small" }) })
  ] });
}, q = (e, t) => e === C ? K(t) : e === "collapsible" ? V(
  t
) : Y(t), Q = (e, t, o) => {
  const n = {
    buttonTypeProps: {},
    buttonHtmlProps: {}
  };
  if (e === C) {
    const { iconType: d, ...N } = t;
    return n.buttonHtmlProps = { ...N, type: "button" }, n.buttonTypeProps = { iconType: d }, n;
  }
  const s = X(o);
  if (e === "collapsible") {
    const {
      buttonText: d,
      buttonTextSize: N,
      panelType: g,
      containsCurrentPageLink: E,
      ...I
    } = t;
    return n.buttonHtmlProps = {
      ...I,
      type: "button",
      "data-text": g === "dropdown" ? `${d} ^^` : ""
    }, n.buttonTypeProps = {
      buttonText: d,
      buttonTextSize: N || s[e][g],
      panelType: g,
      containsCurrentPageLink: E
    }, n;
  }
  const {
    linkType: r,
    buttonText: a,
    buttonTextSize: i,
    showArrow: l = !0,
    ...p
  } = t;
  return n.buttonHtmlProps = {
    ...p,
    "data-text": r === "nav-link" ? a : ""
  }, n.buttonTypeProps = {
    buttonText: a,
    linkType: r,
    buttonTextSize: i || s[e][r],
    showArrow: l
  }, n;
}, W = (e, t) => {
  const o = m.getPropsValueClassName(
    "type",
    e
  );
  if (e === C)
    return o;
  if (e === "collapsible") {
    const { panelType: r, containsCurrentPageLink: a } = t, i = `${o}-${r}`, l = a ? `${i}-page-active` : "";
    return u(o, i, l);
  }
  const { linkType: n } = t, s = `${o}-${n}`;
  return u(o, s);
}, ee = (e, t) => {
  if (e === C)
    return "button";
  if (e === "collapsible") {
    const { panelType: n } = t;
    return n !== "nav-popup" ? "button" : J;
  }
  const { linkType: o } = t;
  return o !== "menu-link" ? x : G;
};
const re = ({ buttonType: e, className: t, ...o }) => {
  const { foundationTheme: n } = _(z), { buttonHtmlProps: s, buttonTypeProps: r } = Q(
    e,
    o,
    n
  ), a = u(
    m.getComponentClassName(),
    W(e, r),
    t
  ), i = ee(e, r);
  return /* @__PURE__ */ c(i, { ...s, className: a, children: q(e, r) });
};
export {
  re as N,
  m as c,
  W as g
};
//# sourceMappingURL=NavButton-bf29eafc.js.map
